module.exports = __webpack_public_path__ + "img/logo.657ad5f1.png";